import { Channel } from './types';
import { getChannelOrderForCurrentGroupId } from './channelOrder';

const compareChannelsAlphabetically = (a: Channel, b: Channel): number => {
    const byName = (a.name || '').localeCompare(b.name || '');
    if (byName !== 0) return byName;
    return String(a._id).localeCompare(String(b._id));
};

export const sortByPersistedOrder = (
    channels: Channel[],
    scopeKey: string
): Channel[] =>
    [...channels].sort((a, b) => {
        const aOrder =
            getChannelOrderForCurrentGroupId(a.channelOrder, scopeKey) ??
            Number.MAX_SAFE_INTEGER;
        const bOrder =
            getChannelOrderForCurrentGroupId(b.channelOrder, scopeKey) ??
            Number.MAX_SAFE_INTEGER;
        if (aOrder !== bOrder) return aOrder - bOrder;
        return compareChannelsAlphabetically(a, b);
    });

export const sortByExplicitOrder = (
    channels: Channel[],
    orderedChannelIds: string[]
): Channel[] => {
    const indexMap = new Map<string, number>(
        orderedChannelIds.map((channelId, index) => [String(channelId), index])
    );

    return [...channels].sort((a, b) => {
        const aIndex = indexMap.get(String(a._id));
        const bIndex = indexMap.get(String(b._id));
        if (aIndex !== undefined && bIndex !== undefined)
            return aIndex - bIndex;
        if (aIndex !== undefined) return -1;
        if (bIndex !== undefined) return 1;
        return compareChannelsAlphabetically(a, b);
    });
};
